import mountLanguage from './langs/mountLanguage';
import enUS from './langs/en-US';
import ptBR from './langs/pt-BR';
import esES from './langs/es-ES';

export default {
  'en-US': mountLanguage(enUS),
  'pt-BR': mountLanguage(ptBR),
  'es-ES': mountLanguage(esES),
};
